import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { loginLogic, toastLogic } from '../../logic';

function AccessDenyLayout({ children }: { children?: React.ReactNode }) {
	const navigate = useNavigate();

	useEffect(() => {
		if (!loginLogic.isLogin()) {
			toastLogic.loginToast();
			navigate('/');
		}
	}, []);

	return (
		<>
			<Outlet />
			{children}
		</>
	);
}

export default AccessDenyLayout;
